import React from "react"

export default function PrivacyPolicy() {

    return (
        <h3 id="h3privacy">Privacy Policy Овај сајт користи колачиће (cookies) ради побољшања корисничког искуства и анализе посјета.

Можемо прикупљати основне техничке податке као што су тип уређаја, прегледач и посјећене странице, искључиво у аналитичке сврхе.

Лични подаци се не прикупљају без изричитог пристанка корисника.

Коришћењем овог сајта слажете се са овом политиком приватности.

Контакт: info@skisnjesko.com</h3>
    )}